export interface EventProps {
  id: string;
  featuredImage: {
    node: {
      sourceUrl: string;
    };
  };
  excerpt: string;
  slug: string;
  title: string;
}

export interface EventQueryProps {
  posts: {
    nodes: Array<EventProps>;
    pageInfo: {
      endCursor: string;
      hasNextPage: string;
    };
  };
}

export interface PageInfo {
  endCursor?: string;
  startCursor?: string;
  hasNextPage?: boolean;
  hasPreviousPage?: boolean;
}

export enum ProductTaxonomyEnum {
  PABLUETOOTH = "PA_BLUETOOTH",
  PAMADHESIA = "PA_MADHESIA",
  PAMOSHA = "PA_MOSHA",
  PANGJYRA = "PA_NGJYRA",
  PAGJINIA = "PA_GJINIA",
  PAFURNIZUESIRRYME = "PA_FURNIZUESIRRYME",
  PAGARANCION = "PA_GARANCION",
  PAHDDSSD = "PA_HDDSSD",
  PAKARTELAGRAFIKE = "PA_KARTELAGRAFIKE",
  PAKOHAEVONESAVE = "PA_KOHAEVONESAVE",
  PALIDHESE = "PA_LIDHESE",
  PAPROCESOR = "PA_PROCESOR",
  PARAMMEMORY = "PA_RAMMEMORY",
  PASERIA = "PA_SERIA",
  PASHKALLAERIFRESKIMIT = "PA_SHKALLAERIFRESKIMIT",
  PASISTEMIOPERATIV = "PA_SISTEMIOPERATIV",
  PATASTIERAMEKANIKE = "PA_TASTIERAMEKANIKE",
  PRODUCTBRAND = "PRODUCT_BRANDS",
  PRODUCTCATEGORY = "PRODUCT_CAT",
  PRODUCTTAG = "PRODUCT_TAG",
  PRODUCTTYPE = "PRODUCT_TYPE",
  SHIPPINGCLASS = "PRODUCT_SHIPPING_CLASS",
  VENDOR = "VENDOR",
  VISIBLEPRODUCT = "PRODUCT_VISIBILITY",
  PAIR = "PA_IR",
  PARESOLUTIO = "PA_RESOLUTION",
  PALEN = "PA_LEN",
  PAALTROPALANTE = "PA_ALTROPALANTE",
  PAZOOM = "PA_ZOOM",
  PAPOE = "PA_POE",
  PAFUQIA = "PA_FUQIA",
  PAGJATESIA = "PA_GJATESIA",
  PAKATEGORIA = "PA_KATEGORIA",
  PASASIA = "PA_SASIA",
  PAVAZHDUSE = "PA_VAZHDUSE",
  PADENDESIA = "PA_DENDESIA",
  PARG = "PA_RG",
  PAEKRANI = "PA_EKRANI",
  PANUMRIIKONEKTORVE_LAN = "PA_NUMRIIKONEKTORVE_LAN",
  PALLOJIIKABLLOSE = "PA_LLOJIIKABLLOSE",
  PAKAPACITETIIDISKUT = "PA_KAPACITETIIDISKUT",
  PAFUQIAEFURNIZUESIT_TE_ENERGJISE = "PA_FUQIAEFURNIZUESIT_TE_ENERGJISE",
  PANUMRIIKANELEVE_CHANNEL = "PA_NUMRIIKANELEVE_CHANNEL",
  PALLOJIIKONEKTOREVE = "PA_LLOJIIKONEKTOREVE",
  PATIPIIKONEKTOREVE = "PA_TIPIIKONEKTOREVE",
  PASUPPORT = "PA_SUPPORT",
}

export enum TaxonomyOperatorEnum {
  AND = "AND",
  EXISTS = "EXISTS",
  IN = "IN",
  NOT_EXISTS = "NOT_EXISTS",
  NOT_IN = "NOT_IN",
}

export interface ProductTaxonomyFilterInput {
  taxonomy: ProductTaxonomyEnum;
  terms: string | string[];
  operator?: TaxonomyOperatorEnum;
}

export interface Coupon {
  id: string;
  code: string;
  amount: number | string;
  discountType: string;
}

export interface AttributeTerms {
  count: number;
  id: string;
  name: string;
  slug: string;
}

export interface AttributeFilter {
  id: string;
  name: string;
  slug: string;
  label: string;
  terms: AttributeTerms[];
}

export interface ChosenAttributesInput extends ProductTaxonomyFilterInput {}
